import { render, staticRenderFns } from "./StartMenu.vue?vue&type=template&id=52838b0a&scoped=true&"
import script from "./StartMenu.vue?vue&type=script&lang=js&"
export * from "./StartMenu.vue?vue&type=script&lang=js&"
import style0 from "./StartMenu.vue?vue&type=style&index=0&id=52838b0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52838b0a",
  null
  
)

export default component.exports